import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Form, Row, Col, Button, Select } from "antd";
import { HeaderLeftItemsWrapper, HomePageHeader } from "../Common";
import {
  HMGSelect,
  ProjectPMSSelect,
  ProjectPMSHotelSelect,
  ProjectSelect,
  HotelSelect,
} from "../Common/DataAttachedElements";
import { REPORT_TYPES } from "../../utils/report";
import { PMS_ALL_VALUE } from "../../utils/pms.utils";

const { Option } = Select;

const BulkReportDeleteTopBar = ({
  hmg,
  setHmg,
  project,
  setProject,
  pms,
  setPMS,
  hotel,
  setHotel,
  isLoading,
  dataRetrievalFn,
  setHmgRef,
  setProjectRef,
  setPMSRef,
  setHotelListRef,
}) => {

  return (
    <HomePageHeader>
      <Col xxl={20} xl={24} lg={24} md={24} sm={24}>
        <Form layout="vertical">
          <HeaderLeftItemsWrapper>
            <Col xxl={5} xl={5} lg={5} md={10} sm={24} xs={24}>
              <Form.Item label="Hotel Management Group">
                <HMGSelect
                  value={hmg}
                  onChange={setHmg}
                  autoDisable
                  setHmgListRef={setHmgRef}
                />
              </Form.Item>
            </Col>
            <Col xxl={5} xl={5} lg={5} md={10} sm={24} xs={24}>
              <Form.Item label="Project">
                <ProjectSelect
                  hmgId={hmg}
                  value={project}
                  onChange={setProject}
                  disabled={!hmg}
                  setProjectListRef={setProjectRef}
                />
              </Form.Item>
            </Col>
            <Col xxl={3} xl={3} lg={3} md={4} sm={24} xs={24}>
              <Form.Item label="PMS">
                <ProjectPMSSelect
                  projectId={project}
                  value={pms}
                  onChange={setPMS}
                  disabled={!project}
                  setProjectPMSListRef={setPMSRef}
                />
              </Form.Item>
            </Col>
            <Col xxl={5} xl={5} lg={5} md={8} sm={24} xs={24}>
              <Form.Item label="Hotel">
                {pms !== PMS_ALL_VALUE ? (
                  <ProjectPMSHotelSelect
                    value={hotel}
                    onChange={setHotel}
                    projectId={project}
                    pmsId={pms}
                    disabled={!project || !pms}
                    setPMSHotelListRef={setHotelListRef}
                    excludedHotelStatus={[]}
                  />
                ) : (
                  <HotelSelect
                    value={hotel}
                    onChange={setHotel}
                    projectId={project}
                    disabled={!project || !pms}
                    setHotelListRef={setHotelListRef}
                    multiple={false}
                    placeholder="Hotel"
                    excludedHotelStatus={[]}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xxl={1} xl={1} lg={1} md={2} sm={4} xs={4}>
              <Form.Item label=" ">
                <Button
                  loading={isLoading}
                  type="primary"
                  disabled={!hotel}
                  onClick={dataRetrievalFn}
                >
                  Go
                </Button>
              </Form.Item>
            </Col>
          </HeaderLeftItemsWrapper>
        </Form>
      </Col>
    </HomePageHeader>
  );
};

BulkReportDeleteTopBar.defaultProps = {
  hmg: undefined,
  setHmg: () => {},
  project: undefined,
  setProject: () => {},
  pms: undefined,
  setPMS: () => {},
  hotel: undefined,
  setHotel: () => {},
  isLoading: false,
  dataRetrievalFn: () => {},
  setHmgRef: () => {},
  setProjectRef: () => {},
};

BulkReportDeleteTopBar.propTypes = {
  hmg: PropTypes.string,
  setHmg: PropTypes.func,
  project: PropTypes.string,
  setProject: PropTypes.func,
  pms: PropTypes.string,
  setPMS: PropTypes.func,
  hotel: PropTypes.string,
  setHotel: PropTypes.func,
  isLoading: PropTypes.bool,
  dataRetrievalFn: PropTypes.func,
  setHmgRef: PropTypes.func,
  setProjectRef: PropTypes.func,
};

export default BulkReportDeleteTopBar;
